import { EditPostType } from 'models/posts.model';
import moment from 'moment';

export const getPostPayload = (
  editPostForm: EditPostType,
  isDetailsPage: boolean,
  isTimelinePage: boolean
) => {
  let payload = {};

  if (isDetailsPage) {
    payload = {
      heading: editPostForm.heading,
      title: editPostForm.title,
      body: editPostForm.body,
      images: editPostForm.image,
      polygon_ids: editPostForm.location,
      post_type: editPostForm.post_type,
      ...(editPostForm.meal_id !== '' && { meal_id: editPostForm.meal_id }),
      ...(editPostForm.brand_id !== '' && { brand_id: editPostForm.brand_id })
    };
  } else if (isTimelinePage) {
    payload = {
      to_start_date: moment(editPostForm.start_date).format('YYYY-MM-DD'),
      to_start_time: `${editPostForm?.start_time?.timeWithColon}:00`,
      ...(editPostForm.end_date && {
        to_expire_date: moment(editPostForm.end_date).format('YYYY-MM-DD')
      }),
      ...(editPostForm?.end_time?.timeWithColon && {
        to_expire_time: `${editPostForm.end_time.timeWithColon}:00`
      })
    };
  }

  return payload;
};
